'use client'

import { useEffect, useRef } from 'react'
import Modal from 'react-modal'

/**
 * ModalInitializer
 *
 * Initializes react-modal's app element once at the app level.
 * This replaces the 27+ individual setAppElement calls scattered across modals.
 *
 * react-modal needs to know the app root element so it can:
 * - Hide the main content from screen readers when a modal is open
 * - Manage focus trapping properly
 *
 * This component:
 * - Calls setAppElement only once (not on every modal mount)
 * - Waits for the element to exist before calling
 * - Fails silently if element doesn't exist (prevents cascade errors)
 */
export default function ModalInitializer() {
    const initialized = useRef(false)

    useEffect(() => {
        if (initialized.current) return

        const appElement = document.getElementById('hivenext')
        if (appElement) {
            Modal.setAppElement(appElement)
            initialized.current = true
        } else {
            // Element doesn't exist yet or at all - log but don't crash
            console.warn('[ModalInitializer] #hivenext element not found. Modals may not work correctly for screen readers.')
        }
    }, [])

    return null
}
